"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const ToasterNotification_1 = __importDefault(require("../../../../global/js/Utils/ToasterNotification"));
function ExceptionAxios(messageBag, callback) {
    if (lodash_1.default.isUndefined(messageBag)) {
        callback();
    }
    else if (lodash_1.default.isString(messageBag)) {
        ToasterNotification_1.default.error(5, messageBag);
    }
    else if (lodash_1.default.isObject(messageBag)) {
        ToasterNotification_1.default.setOptions(messageBag.type, 5, messageBag.message);
    }
}
exports.default = ExceptionAxios;
